// extracted by mini-css-extract-plugin
module.exports = {"merchant":"TransactionMenuPage_merchant__1MM5r","option":"TransactionMenuPage_option__1Is58"};